module.exports = __webpack_public_path__ + "static/media/layout1-vid.2b3cd4a3.svg";